import { httpsCallable } from "firebase/functions";
import { functions } from "./firebase";

export async function getProfilePhoto() {
  try { return (await httpsCallable(functions, "getProfilePhoto")({})).data; }
  catch { return { error: "read" }; }
}
export async function uploadProfilePhoto(file) {
  if (!file || !["image/jpeg", "image/png", "image/webp"].includes(file.type) || file.size > 2 * 1024 * 1024) return { error: "file" };
  try {
    const dataUrl = await new Promise((resolve, reject) => {
      const reader = new FileReader(); reader.onload = () => resolve(reader.result); reader.onerror = reject; reader.readAsDataURL(file);
    });
    return (await httpsCallable(functions, "uploadProfilePhoto")({ imageBase64: dataUrl.split(",")[1], mimeType: file.type })).data;
  } catch { return { error: "write" }; }
}
